import { useQuery } from '@tanstack/vue-query'
import { computed } from 'vue'

import { useAuth } from 'src/composables/app/useAuth'
import { refetchEnabledWhenVisible } from 'src/composables/app/system/useOnlineStatus'

import { companiesService } from 'src/services/api/companies.service'
import { STORAGE_KEYS } from 'src/services/consts/api.const'

export function useCompanies() {
  const { user } = useAuth()

  const enableQuery = computed(() => !!user.value?.id)

  const companiesQuery = useQuery({
    queryKey: [STORAGE_KEYS.COMPANIES, computed(() => user.value?.id)],
    queryFn: () => companiesService.getCompanies(),
    enabled: enableQuery,
    refetchOnWindowFocus: enableQuery,
    refetchOnReconnect: refetchEnabledWhenVisible(enableQuery),
  })

  const companies = computed(() => companiesQuery.data.value || [])
  const isLoading = computed(
    () =>
      companiesQuery.isLoading.value ||
      companiesQuery.isFetching.value ||
      companiesQuery.isRefetching.value,
  )

  return {
    companies,
    isLoading,
    error: companiesQuery.error,
  }
}
